export default __webpack_public_path__ + "static/media/48.0acc15a4.png";